/**
 * Handles variant image hover functionality on product cards
 * When hovering over a variant thumbnail, the main product image is replaced with the variant image
 */
if (!window.cardProductVariantHover) {
  class CardProductVariantHover {
    constructor() {
      this.init();
    }

    init() {
      // Find all variant items on the page
      const variantItems = document.querySelectorAll('.card__variant-item');

      variantItems.forEach((variantItem) => {
        variantItem.addEventListener('click', this.handleVariantClick.bind(this));
        variantItem.addEventListener('mouseenter', this.handleVariantHover.bind(this));
        variantItem.addEventListener('mouseleave', this.handleVariantLeave.bind(this));
      });

      // Also handle mouse leave on the entire card wrapper to restore image
      const cardWrappers = document.querySelectorAll('.product-card-wrapper');
      cardWrappers.forEach((cardWrapper) => {
        cardWrapper.addEventListener('mouseleave', this.handleCardLeave.bind(this));
      });
    }

    handleVariantClick(event) {
      event.preventDefault();

      const cardWrapper = event.target.closest('.product-card-wrapper');

      const variantItems = cardWrapper.querySelectorAll('.card__variant-item');
      const activeVariantItems = event.target.closest('.card__variant-item');

      variantItems.forEach(item => item.classList.remove('card__variant-item--active'));
      activeVariantItems?.classList.add('card__variant-item--active');

      this.updateMainImage(activeVariantItems);
      this.updateProductLink(cardWrapper, activeVariantItems);
    }

    handleVariantHover(event) {
      const variantItem = event.currentTarget;
      const cardImageId = variantItem.getAttribute('data-card-image-id');
      const variantSrcset = variantItem.getAttribute('data-variant-image-srcset');
      const variantSrc = variantItem.getAttribute('data-variant-image-src');

      if (!cardImageId || !variantSrcset || !variantSrc) {
        return;
      }

      const mainImage = document.getElementById(cardImageId);
      if (!mainImage) {
        return;
      }

      // Store original values if not already stored
      if (!mainImage.dataset.originalSrcset) {
        mainImage.dataset.originalSrcset = mainImage.getAttribute('srcset') || mainImage.getAttribute('data-original-srcset') || '';
        mainImage.dataset.originalSrc = mainImage.getAttribute('src') || mainImage.getAttribute('data-original-src') || '';
      }

      // Replace with variant image
      mainImage.setAttribute('srcset', variantSrcset);
      mainImage.setAttribute('src', variantSrc);
    }

    handleVariantLeave(event) {
      // Use a small timeout to check if mouse moved to another variant
      // This prevents flickering when moving between variants
    const variantItem = event.currentTarget;

    setTimeout(() => {
        const cardWrapper = variantItem?.closest('.product-card-wrapper');

        if (!cardWrapper) {
          this.restoreImage(variantItem);
          return;
        }

        // Check if mouse is still over any variant in this card
        const activeVariant = cardWrapper.querySelector('.card__variant-item:hover');
        if (!activeVariant) {
          // Mouse is not over any variant, restore original image
          this.restoreImage(variantItem);
        }
      }, 50);
    }

    handleCardLeave(event) {
      // Find all variant items in this card and restore the image
      const cardWrapper = event.currentTarget;
      const variantItems = cardWrapper.querySelectorAll('.card__variant-item');

      if (variantItems.length > 0) {
        this.restoreImage(variantItems[0]);
      }
    }

    restoreImage(variantItem) {
      const cardImageId = variantItem?.getAttribute('data-card-image-id');

      if (!cardImageId || !variantItem) {
        return;
      }

      const mainImage = document.getElementById(cardImageId);

      if (!mainImage || !mainImage.dataset.originalSrcset) {
        return;
      }

      // Restore original image
      mainImage.setAttribute('srcset', mainImage.dataset.originalSrcset);
      mainImage.setAttribute('src', mainImage.dataset.originalSrc);
    }

    updateMainImage(variantItem) {
      if (!variantItem) return;

      const cardImageId = variantItem.getAttribute('data-card-image-id');
      const variantSrcset = variantItem.getAttribute('data-variant-image-srcset');
      const variantSrc = variantItem.getAttribute('data-variant-image-src');

      if (!cardImageId || !variantSrcset || !variantSrc) return;

      const mainImage = document.getElementById(cardImageId);
      if (!mainImage) return;

      mainImage.dataset.originalSrcset = variantSrcset;
      mainImage.dataset.originalSrc = variantSrc;
      mainImage.setAttribute('srcset', variantSrcset);
      mainImage.setAttribute('src', variantSrc);
    }

    updateProductLink(cardWrapper, variantItem) {
      if (!cardWrapper || !variantItem) return;

      const variantUrl = variantItem.getAttribute('href');
      if (!variantUrl) return;

      cardWrapper.querySelectorAll('[data-link-to-product]').forEach(item => item?.setAttribute('href', variantUrl));
    }
  }

// Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.cardProductVariantHover ??= new CardProductVariantHover();
    });
  } else {
    window.cardProductVariantHover ??= new CardProductVariantHover();
  }

// Re-initialize for dynamically loaded content (e.g., AJAX-loaded product cards)
  document.addEventListener('shopify:section:load', () => {
    window.cardProductVariantHover ??= new CardProductVariantHover();
  });
}